import React, { useEffect, useState } from "react";

const InstallButton: React.FC = () => {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = (e: Event) => {
      console.log("beforeinstallprompt fired!", e);
      e.preventDefault();
      setDeferredPrompt(e);
      setVisible(true); // Show the button
    };
    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstallClick = () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt(); // Show the browser install prompt
    deferredPrompt.userChoice.then((choiceResult: any) => {
      if (choiceResult.outcome === "accepted") {
        console.log("User accepted the A2HS prompt");
      } else {
        console.log("User dismissed the A2HS prompt");
      }
      setDeferredPrompt(null);
      setVisible(false);
    });
  };

  if (!visible) return null;

  return <button onClick={handleInstallClick}>Install App</button>;
};

export default InstallButton;
